/* eslint-disable no-unused-vars */
import { Tag, Tags, UploadItems } from 'store/types';
import reduce from 'lodash-es/reduce';
import each from 'lodash-es/each';
import values from 'lodash-es/values';
import intersectionBy from 'lodash-es/intersectionBy';

export type Group = {
  groupId: string;
  groupTags: Tags;
  items: UploadItems;
};

export const getGrop: (items: UploadItems) => Group = (items) => {
  let allTags: Tag[][] = [];

  // Сначала создадим массив из массивов тегов
  each(items, (item) => allTags.push(values(item.tags)));

  // Начиная с массива тегов первого элемента, ищем пересечение с остальными
  const intersection = reduce(
    allTags,
    (acc: Tag[], tags) => {
      acc = intersectionBy(acc, tags, 'name');

      return acc;
    },
    allTags[0]
  );

  const result = {
    // Чтобы не плодить по проекту типы, конвертируем обратно
    groupTags: reduce(
      intersection,
      (acc: Tags, tag) => {
        acc[tag.name] = tag;
        return acc;
      },
      {}
    ),
    // Порядок выбора картинок не влияет на их порядок, поэтому
    // Можно получить уникальный для группы хэш простой конкатинацией
    groupId: reduce(
      items,
      (acc, item) => {
        acc += item.id;
        return acc;
      },
      ''
    ),
    items: items,
  };

  return result;
};
